import {createContext, useContext} from 'react';

const PreviewContext = createContext({
    isPreview: false,
    previewClientId: null,
    previewModules: null,
    previewBranding: null,
});

export const PreviewProvider = PreviewContext.Provider;

export const usePreviewContext = () => useContext(PreviewContext);
